module.exports = __webpack_public_path__ + "static/media/1_pl.93e7c5ea.png";